const { DESKTOP, MOBILE, MOBILE_NAV_BREAKPOINT } = require('./Constants');

const getDevice = (deviceContext = window) => {
  if (deviceContext.navigator.userAgent.match(/mobi|android|touch|mini|tablet|iPad|iPhone|iPod|android|webOS/i) || (deviceContext.innerWidth < MOBILE_NAV_BREAKPOINT)) {
    return MOBILE;
  }
  return DESKTOP;
};

module.exports = {
  getDevice,
};

